module.exports = __webpack_public_path__ + "static/media/p1_6.16acd20d.png";